module.exports = {"url":{"hash":"/resources/syncHash.json","sync":"/resources/sync.json"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/sync.zh.json
// module id = 972
// module chunks = 0